import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CartItem } from 'retail/app/common/models/cart-item';
import { CartService } from 'retail/app/common/providers/cart.service';
import { RetailAnalyticsService } from 'retail/app/retail-analytics.service';
import { environment } from 'retail/environments/environment';
import { FlashMessages } from 'shared-ui/providers/flash-messages';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss'],
})
export class CartComponent implements OnInit {
  readonly defaultImage = '/assets/placeholder.jpg';

  readonly checkoutLink = '/o/objednavka';

  items: CartItem[] = [];

  constructor(
    private cartService: CartService,
    private flashMessages: FlashMessages,
    private router: Router,
    private meta: Meta,
    private title: Title,
    private analyticsService: RetailAnalyticsService
  ) {
    this.setMetadata();
  }

  get itemsPrice() {
    return this.cartService.getItemsPrice();
  }

  getImageUrl(item: CartItem): string {
    return `${environment.imagesUrl}/products/${item.id}/${item.image}`;
  }

  ngOnInit(): void {
    this.items = this.cartService.cartItems;
    this.analyticsService.logViewCart(this.items);
    this.cartService.cartUpdate.subscribe(value => (this.items = value));
  }

  stepperChange(event: StepperSelectionEvent) {
    if (event.selectedIndex > 0) {
      this.router.navigate([this.checkoutLink]);
    }
  }

  updateQuantity(item: CartItem, count: number) {
    this.cartService.updateCountForItem(item, count);
  }

  removeFromCart(item: CartItem) {
    this.cartService.removeFromCart(item);
    this.flashMessages.show('Product was removed from shopping cart.');
  }

  clearCart() {
    this.cartService.clearCart();
    this.flashMessages.show('Your shopping cart is empty.');
  }

  private setMetadata() {
    this.title.setTitle(`Košík | BEROP.cz`);
    this.meta.updateTag({
      name: 'keywords',
      content: 'Košík',
    });
    this.meta.updateTag({
      name: 'description',
      content: 'Košík',
    });
  }
}
